import { delegateInit } from './BaseShape';
import { ReturnStatement } from './ReturnStatement';

const ENTITY_FIELD_NAME = 'BreakStatement';

export default delegateInit(ReturnStatement, ENTITY_FIELD_NAME);
